import { render } from "./IndexHistory.vue?vue&type=template&id=7552c416&scoped=true"
import script from "./IndexHistory.vue?vue&type=script&lang=js"
export * from "./IndexHistory.vue?vue&type=script&lang=js"

import "./IndexHistory.vue?vue&type=style&index=0&id=7552c416&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7552c416"]])

export default __exports__